import { createContext, useContext } from "react";

export interface IWhatsNewContext {
  /** Falso fora do WhatsNewProvider, para quem consome esconder a entrada de novidades. */
  available: boolean;
  releaseTitle: string;
  openWhatsNew: () => void;
}

export const WhatsNewContext = createContext<IWhatsNewContext>({
  available: false,
  releaseTitle: "",
  openWhatsNew: () => undefined,
});

/** Acesso ao modal de novidades da versão (abrir de novo pelo sininho, por exemplo). */
export const useWhatsNew = () => useContext(WhatsNewContext);
